export const SearchService = {
    searchWorker: null,

    searchGames({
        searchQuery,
        allGamesById,
        themePublicPath,
    }) {
        if (!this.searchWorker) {
            this.searchWorker = new Worker(`${themePublicPath}/workers/games-search.worker.js`);
        }

        return new Promise((resolve, reject) => {
            this.searchWorker.postMessage({
                searchQuery,
                allGamesById,
            });

            this.searchWorker.onmessage = (e) => {
                resolve(e.data);
            };

            this.searchWorker.onerror = () => {
                reject(new Error('SearchService.searchGames() failed'));
            };
        });
    },
};
